import React from "react";
import {
  Typography,
  Box,
  Tooltip
} from "@mui/material";
import { BsEyeFill, BsPencilSquare, BsTrashFill, BsToggleOn, BsToggleOff } from "react-icons/bs";
import Swal from "sweetalert2";
import usericon from './user.png'
import './main.css'

const actionButtonStyles = (type) => {
  const colors = {
    more: { bg: '#eff6ff', color: '#2563eb', hoverBg: '#2563eb', hoverColor: '#ffffff' },
    edit: { bg: '#f0fdf4', color: '#16a34a', hoverBg: '#16a34a', hoverColor: '#ffffff' },
    delete: { bg: '#fef2f2', color: '#dc2626', hoverBg: '#dc2626', hoverColor: '#ffffff' },
    status: { bg: '#fff7ed', color: '#ea580c', hoverBg: '#ea580c', hoverColor: '#ffffff' }
  };
  const activeColor = colors[type];
  return {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: activeColor.bg,
    color: activeColor.color,
    cursor: 'pointer',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: activeColor.hoverBg,
      color: activeColor.hoverColor,
      transform: 'scale(1.06)'
    }
  };
};

export default function InfoCard2({ img_type, icon, type, data, onClick, keys, onAction = () => { } }) {
  const handleClick = onClick || (() => { });

  const avatar = (type, data, keys) => {
    const imageSrc = data[keys[0]];
    const srcPath = type === "user" ? usericon : imageSrc;
    return (
      <Box
        component="img"
        src={srcPath}
        loading="lazy"
        alt=""
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          objectFit: "cover",
          border: '2px solid #f1f5f9',
          boxShadow: '0 4px 10px rgba(15, 23, 42, 0.04)',
          transition: 'transform 0.25s ease',
          '&:hover': { transform: 'scale(1.05)' }
        }}
      />
    );
  };

  return (
    <Box
      className="move-top"
      sx={{
        borderRadius: '16px',
        p: 3,
        cursor: "pointer",
        position: 'relative',
        height: '100%',
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-3px)',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
          borderColor: '#cbd5e1'
        }
      }}
      onClick={handleClick}
    >
      {/* Action Buttons Top Right */}
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          display: 'flex',
          gap: 0.8,
          zIndex: 10
        }}
      >
        <Tooltip title="View More">
          <Box sx={actionButtonStyles('more')} onClick={(e) => { e.stopPropagation(); onAction("More", data); }}>
            <BsEyeFill fontSize={13} />
          </Box>
        </Tooltip>
        <Tooltip title="Edit">
          <Box sx={actionButtonStyles('edit')} onClick={(e) => { e.stopPropagation(); onAction("Edit", data); }}>
            <BsPencilSquare fontSize={12} />
          </Box>
        </Tooltip>
        {data.is_active !== undefined && (
          <Tooltip title={data.is_active ? "Deactivate" : "Activate"}>
            <Box sx={actionButtonStyles('status')} onClick={(e) => { e.stopPropagation(); onAction("Status", data); }}>
              {data.is_active ? <BsToggleOn fontSize={14} /> : <BsToggleOff fontSize={14} />}
            </Box>
          </Tooltip>
        )}
        <Tooltip title="Delete">
          <Box
            sx={actionButtonStyles('delete')}
            onClick={(e) => {
              e.stopPropagation();
              Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3b82f6",
                cancelButtonColor: "#ef4444",
                confirmButtonText: "Yes, delete it!"
              }).then((result) => {
                if (result.isConfirmed) {
                  onAction("Delete", data);
                }
              });
            }}
          >
            <BsTrashFill fontSize={12} />
          </Box>
        </Tooltip>
      </Box>

      {/* Main content */}
      <Box sx={{ textAlign: 'center', mt: 1, flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box sx={{ height: 80, width: 80, mb: 2 }}>
          {icon ? icon : avatar(type, data, keys)}
        </Box>

        <Tooltip title={data[keys[1]]} arrow placement="top">
          <Typography
            sx={{
              fontSize: '15.5px',
              fontWeight: 700,
              color: '#1e293b',
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              display: "block",
              maxWidth: "100%",
              lineHeight: 1.3,
              textWrap: 'nowrap'
            }}
          >
            {data[keys[1]]}
          </Typography>
        </Tooltip>

        {data[keys[2]] && (
          <Typography sx={{
            textWrap: 'nowrap',
            color: '#64748b',
            fontSize: '13px',
            mt: 0.5,
            fontWeight: 500,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            display: "block",
            maxWidth: "100%",
            lineHeight: 1.3,

          }}>
            {data[keys[2]]}
          </Typography>
        )}

        {data[keys[3]] && (
          <Typography sx={{
            textWrap: 'nowrap',
            color: '#94a3b8',
            fontSize: '11.5px',
            mt: 0.5,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            display: "block",
            maxWidth: "100%",
            lineHeight: 1.3,
          }}>
            {data[keys[3]]}
          </Typography>
        )}
      </Box>

      {/* Stats Bottom Area */}
      <Box sx={{ borderTop: "1px solid #f1f5f9", mt: 2.5, pt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>{data[keys[5]]}</Typography>
          <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.02em', mt: 0.8 }}>{keys[4]}</Typography>
        </Box>
        <Box sx={{ width: '1px', height: '24px', background: '#e2e8f0' }} />
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>{data[keys[7]]}</Typography>
          <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.02em', mt: 0.8 }}>{keys[6]}</Typography>
        </Box>
        <Box sx={{ width: '1px', height: '24px', background: '#e2e8f0' }} />
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>{data[keys[9]]}</Typography>
          <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.02em', mt: 0.8 }}>{keys[8]}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
